<template>
  <v-card class="mx-auto" max-width="800">
    <v-overlay v-if="loader" absolute>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>

    <v-card-title>Detalle de CXC</v-card-title>
    
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <h3>
              <v-icon>mdi-package-variant-closed</v-icon> Cliente: 
              {{ cuenta.clienteData.Nombres }} {{ cuenta.clienteData.Apellidos }}
              <v-btn class="ml-4" color="red" dark @click="generatePdf">
                Generar PDF
              </v-btn>
            </h3>
          </v-col>
          <v-col cols="12">
            <h3>
              <v-icon>mdi-currency-usd</v-icon> Monto: 
              {{ cuenta.Totales.MXN ? cuenta.Totales.MXN : cuenta.Totales.USD }}
              {{ cuenta.Totales.MXN ? " " + $Currencies.getCurrencyDefault() : " USD" }}
            </h3>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-text>
      <v-simple-table>
        <thead>
          <tr>
            <th>Producto</th>
            <th>Cantidad</th>
            <th>Cantidad {{$Currencies.getCurrencyDefault()}}</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(agrupador, index) in calatalogo" >
            <tr style="background: #80808024" :key="index">
              <td colspan="4">Fecha: {{ index }}</td>
            </tr>
            <template v-for="(prod, indexprod) in agrupador" >
              <tr :key="indexprod">
                <td>{{ prod.Nombre }}</td>
                <td>{{ prod.Cnt }}</td>
                <td>${{ $pgsHelper.formatNumber(prod.Pco.C * prod.Cnt) }} {{ prod.Pco.M }}</td>
                <td>{{ prod.fecha }}</td>
              </tr>
            </template>
          </template>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import moment from "moment";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import CxcDetalle from "../../../clases/PdfMakers/CxcDetalle";
import Currency from "../../../clases/Currencies.js";

export default {
  name: "FormCuenta",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      cuenta: {
        clienteData: {},
        Totales: {},
      },
      Id: "",
      errors: {},
      loader: true,
    };
  },
  methods: {
    async generatePdf() {
      let mainData = {
        TITLE:
          "CXC del cliente " +
          this.cuenta.clienteData.Nombres +
          " " +
          this.cuenta.clienteData.Apellidos,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.calatalogo,
        currency: Currency.getCurrencyDefault(),
        monto: this.cuenta.Totales.MXN
          ? this.cuenta.Totales.MXN
          : this.cuenta.Totales.USD,
      };
      let docData = CxcDetalle.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    getDateFormat(data) {
      return moment(data);
    },
    checkForm: function(e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    calatalogo() {
      this.cuenta.Catalogo.forEach((element) => {
        element.fecha = element.ExtraParams.CuentaData.Crat
          ? this.getDateFormat(element.ExtraParams.CuentaData.Crat).format(
              "YYYY-MM-DD HH:mm"
            )
          : "Otros";
      });
      let agrupador = {};
      this.cuenta.Catalogo.forEach((element) => {
        if (!agrupador[element.fecha]) {
          agrupador[element.fecha] = [];
        }
        agrupador[element.fecha].push(element);
      });

      return agrupador;
    },
  },
  watch: {},
  beforeMount: function() {
    this.loader = true;
  },
  mounted() {
    this.loader = false;

    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.cuenta = this.dataEdit;
    }
  },
};
</script>
